import { ExtraChargesType, Status } from "@/core/types/utils";
import { z } from "zod";

export enum DeliveryAt {
	checkOut = "checkOut",
	checkIn = "checkIn",
}

export const DeliveryAtOptions = [
	{ value: DeliveryAt.checkOut, label: "common.checkOut" },
	{ value: DeliveryAt.checkIn, label: "common.checkIn" },
];

export const addOnsFormSchema = z.object({
	name: z.string().min(1).max(40),
	price: z.transform(Number).pipe(z.number().min(0, { error: "val.min0" })),
	addonCode: z.string().max(10).optional(),
	taxPolicyId: z.string().length(16),
	description: z.string().max(350),
	termsAndConditions: z.string().max(500),
	type: z.enum(ExtraChargesType),
	status: z.enum(Status),
	deliveryAt: z.enum(DeliveryAt).nullish(),
});

export const addOnsRateFormSchema = z.object({
	name: z.string().min(1).max(40),
	price: z.transform(Number).pipe(z.number().min(0, { error: "val.min0" })),
	addonCode: z.string().max(100).optional(),
	description: z.string().max(350),
	termsAndConditions: z.string().max(500),
	type: z.enum(ExtraChargesType),
	status: z.enum(Status),
	deliveryAt: z.enum(DeliveryAt).nullish(),
});

export type AddOnsFormValues = z.infer<typeof addOnsFormSchema>;
export type AddOnsFormInputValues = z.input<typeof addOnsFormSchema>;

export const addOnsSchema = addOnsFormSchema.extend({
	id: z.string(),
});

export type AddOn = z.infer<typeof addOnsSchema>;

export type addOnsFormValues = z.output<typeof addOnsFormSchema>;
export type addOnsFormInputValues = z.input<typeof addOnsFormSchema>;
